// COLS
import defaultCols from '@/data/cols/directories/default'
import defaultENCols from '@/data/cols/directories/defaultEN'
import sysDocumentMapping from '@/data/cols/directories/sysDocumentMapping'
import sysLaboratoryTestMapping from '@/data/cols/directories/sysLaboratoryTestMapping'
import sysServiceMapping from '@/data/cols/directories/sysServiceMapping'
import sysIcdEntities from '@/data/cols/directories/sysIcdEntities'
import sysRiskGroupDescriptions from '@/data/cols/directories/sysRiskGroupDescriptions'
import sysDoctoRecommendations from '@/data/cols/directories/sysDoctoRecommendations'
import sysLaboratoryStudyTypeMapping from '@/data/cols/directories/sysLaboratoryStudyTypeMapping'
import sysHis from '@/data/cols/directories/sysHis'

import axios from 'axios'

export default {
  methods: {
    setAddress () {
      switch (this.alias) {
        case 'sys-his':
          return `gate/api/v1/nsi/values/${this.alias}/?`
        case 'sys-laboratory-tests':
          return `symptom-checker/api/v1/nsi/directories/${this.alias}/?`
        default:
          return `dhra/api/v2/nsi/values/${this.alias}/?`
      }
    },
    setClass () {
      switch (this.alias) {
        case 'sys-risk-group-descriptions':
          return 'full_length'
        default:
          return ''
      }
    },
    setFilters () {
      switch (this.alias) {
        case 'sys-document-mapping':
        case 'sys-service-mapping':
          return [
            {
              type: 'WebiomedInput',
              label: 'Наименование',
              search_by: 'name__icontains'
            },
            {
              type: 'WebiomedSelect',
              label: 'Состояние маппинга',
              search_by: 'service__isnull',
              params: {
                options: [
                  {
                    id: 'false',
                    name: 'Размечено'
                  },
                  {
                    id: 'true',
                    name: 'Не размечено'
                  }
                ]
              }
            }
          ]
        case 'sys-laboratory-study-type-mapping':
          return [
            {
              type: 'WebiomedInput',
              label: 'Наименование',
              search_by: 'name__icontains'
            },
            {
              type: 'WebiomedSelect',
              label: 'Состояние маппинга',
              search_by: 'lab_type__isnull',
              params: {
                options: [
                  {
                    id: 'false',
                    name: 'Размечено'
                  },
                  {
                    id: 'true',
                    name: 'Не размечено'
                  }
                ]
              }
            }
          ]
        case 'sys-laboratory-test-mapping':
          return [
            {
              type: 'WebiomedInput',
              label: 'Лабораторное исследование ',
              search_by: 'name__icontains'
            },
            {
              type: 'WebiomedInput',
              label: 'Название лабораторного теста',
              search_by: 'parameter_name__icontains'
            },
            {
              type: 'WebiomedSelect',
              label: 'Состояние маппинга',
              search_by: 'lab_test__isnull',
              params: {
                options: [
                  {
                    id: 'false',
                    name: 'Размечено'
                  },
                  {
                    id: 'true',
                    name: 'Не размечено'
                  }
                ]
              }
            }
          ]
        case 'sys-icd-entities':
        case 'sys-services':
          return [
            {
              type: 'WebiomedInput',
              label: 'Наименование',
              search_by: 'name__icontains'
            },
            {
              type: 'WebiomedInput',
              label: 'Код',
              search_by: 'code__icontains'
            },
            {
              type: 'WebiomedInput',
              label: 'ID',
              search_by: 'id__icontains'
            }
          ]
        case 'sys-risk-group-descriptions': {
          let options = []
          axios
            .get('dhra/api/v2/nsi/values/sys-methodology/?limit=500&&is_active=true')
            .then(values => {
              for (let key in values.data.results) {
                options.push({
                  id: values.data.results[key].id,
                  name: values.data.results[key].name
                })
              }
            })
          return [
            {
              type: 'WebiomedInput',
              label: 'Наименование',
              search_by: 'name__icontains'
            },
            {
              type: 'WebiomedSelect',
              label: 'Состояние маппинга',
              search_by: 'methodology',
              params: {
                options
              }
            }
          ]
        }
        case 'sys-his': {
          let options = []
          axios
            .get('dhra/api/v2/nsi/values/sys-type-of-information-system/?limit=500&&is_active=true')
            .then(values => {
              for (let key in values.data.results) {
                options.push({
                  id: values.data.results[key].id,
                  name: values.data.results[key].name
                })
              }
            })
          return [
            {
              type: 'WebiomedInput',
              label: 'Наименование',
              search_by: 'name__icontains'
            },
            {
              type: 'WebiomedSelect',
              label: 'Тип',
              search_by: 'type',
              params: {
                options
              }
            },
            {
              type: 'WebiomedInput',
              label: 'ID',
              search_by: 'id__icontains'
            }
          ]
        }
        default:
          return [
            {
              type: 'WebiomedInput',
              label: 'Наименование',
              search_by: 'name__icontains'
            },
            {
              type: 'WebiomedInput',
              label: 'Код',
              search_by: 'code__icontains'
            },
            {
              type: 'WebiomedInput',
              label: 'ID',
              search_by: 'id__icontains'
            }
          ]
      }
    },
    setCols () {
      switch (this.alias) {
        case 'sys-risk-groups':
        case 'sys-methodology':
        case 'sys-nosologies':
        case 'sys-risk-factors':
          return defaultENCols
        case 'sys-document-mapping':
          return sysDocumentMapping
        case 'sys-laboratory-study-type-mapping':
          return sysLaboratoryStudyTypeMapping
        case 'sys-laboratory-test-mapping':
          return sysLaboratoryTestMapping
        case 'sys-service-mapping':
          return sysServiceMapping
        case 'sys-icd-entities':
        case 'sys-services':
          return sysIcdEntities
        case 'sys-risk-group-descriptions':
          return sysRiskGroupDescriptions
        case 'sys-doctor-recommendations':
        case 'sys-patient-recommendations':
          return sysDoctoRecommendations
        case 'sys-his':
          return sysHis
        default:
          return defaultCols
      }
    },
    setData (response) {
      this.data = response.map(item => {
        switch (this.alias) {
          case 'sys-risk-groups':
          case 'sys-methodology':
          case 'sys-nosologies':
          case 'sys-risk-factors':
            return {
              id: item.id,
              name: item.name,
              name_en: item.name_en,
              code: item.code,
              is_active: item.is_active ? 'Да' : 'Нет'
            }
          case 'sys-document-mapping':
            return {
              parentID: this.$route.params.id,
              id: item.id,
              alias: this.alias,
              name: item.name,
              service_text: item.service_text
            }
          case 'sys-laboratory-test-mapping':
            return {
              parentID: this.$route.params.id,
              id: item.id,
              alias: this.alias,
              name: item.name,
              parameter_name: item.parameter_name,
              lab_test_text: item.lab_test_text
            }
          case 'sys-service-mapping':
            return {
              parentID: this.$route.params.id,
              id: item.id,
              alias: this.alias,
              name: item.name,
              oms_code: item.oms_code,
              mo_code: item.mo_code,
              service: item.service_text
            }
          case 'sys-laboratory-study-type-mapping':
            return {
              parentID: this.$route.params.id,
              id: item.id,
              alias: this.alias,
              name: item.name,
              lab_type_text: item.lab_type_text
            }
          case 'sys-icd-entities':
          case 'sys-services':
            return {
              id: item.id,
              name: item.name,
              code: item.code
            }
          case 'sys-risk-group-descriptions':
            return {
              parentID: this.$route.params.id,
              alias: this.alias,
              id: item.id,
              methodology: item.methodology,
              name: item.name,
              methodology_text: item.methodology_text
            }
          case 'sys-doctor-recommendations':
          case 'sys-patient-recommendations':
            return {
              parentID: this.$route.params.id,
              alias: this.alias,
              id: item.id,
              name: item.name,
              code: item.code,
              is_active: item.is_active ? 'Да' : 'Нет'
            }
          case 'sys-his':
            return {
              id: item.id,
              name: item.name,
              type: item.type_text,
              is_active: item.is_active ? 'Да' : 'Нет'
            }
          default:
            return {
              id: item.id,
              name: item.name,
              short_name: item.short_name,
              code: item.code,
              is_active: item.is_active ? 'Да' : 'Нет'
            }
        }
      })
    }
  }
}
